<template>
  <div>
    <headerPart />
    <firstPart />
    <secondPart />
    <thirdPart />
    <footerPart />
  </div>
</template>

<script>
import headerPart from "../components/Header.vue";
import firstPart from "../components/FirstPart.vue";
import secondPart from "../components/SecondPart.vue";
import thirdPart from "../components/ThirdPart.vue";
import footerPart from "../components/FooterPart.vue";

export default {
  name: "Home",
  components: {
    headerPart,
    firstPart,
    secondPart,
    thirdPart,
    footerPart,
  },
  methods: {},
};
</script>

<style></style>
